import React from "react";
import "./striped-progress-bar.css";

export default function StripedProgressBar({
                                               value = 0, // 0 - 100
                                               height = 16,
                                               striped = true,
                                               animated = true,
                                               className = "",
                                               ariaLabel = "Progress",
                                           }) {
    const pct = Math.max(0, Math.min(100, Number(value)));


    return (
        <div
            className={`striped-progress-root ${className}`}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={pct}
            aria-label={ariaLabel}
            style={{ "--bar-height": `${height}px` }}
        >
            <div className="striped-progress-track">
                <div
                    className={`striped-progress-bar ${animated && striped ? "animated" : ""}`}
                    style={{ width: `${pct}%` }}
                >
                    <div className="striped-progress-label">{pct}%</div>
                </div>
            </div>
        </div>
    );
}
